// src/pages/About.jsx
import React from 'react';
import Professional from '../assets/logos/yoyo.png';
import Professional01 from '../assets/images/Andy_.png';
import Professional02 from '../assets/images/Luyanda_.png';
// import Professional03 from '../assets/images/professional03.jpeg';
import bg from '../assets/images/companyImg.JPG'; 

function About() {
  return (
    <div className="position-relative overflow-hidden">
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', 
          opacity: 0.3, 
          zIndex: 0, 
        }}
      ></div>

      <div className="container py-3 position-relative z-1 text-dark">
        <h1 className="mb-4 text-center display-4 fw-bold ">About Us</h1>
        <p className="lead text-center mb-5">
          <strong> LIYO & SONS GROUP (PTY) Ltd </strong>is a versatile and professional enterprise registered under CK number 2023/771034/07.
          We specialize in civil engineering, general building construction, maintenance, landscaping, fencing, renovations,
          and consulting services. Our company is built on a foundation of integrity, innovation, and commitment to quality.
        </p>

        {/* Our Team Section */}
        <section className="my-5 py-0 mb-5 position-relative z-1">
          <h3 className="mb-4 text-center">Meet Our Team</h3>
          <p className="lead text-center mb-5">
            Our success is driven by a dedicated team of experts committed to excellence.
          </p>
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 justify-content-center">
            {/* Team Member 1 */}
            <div className="col">
              <div className="card h-100 bg-warning text-center">
                <img
                  src={Professional} 
                  className="card-img-top mx-auto mt-4 rounded-circle"
                  alt="Team Member Name"
                  style={{ width: '150px', height: '150px', objectFit: 'center' }}
                />
                  <h5 className="card-title mb-1">Yonke Mlobeli</h5>
                  <p className="card-text small">Managing Director</p>
                  <p className="card-text">
                    A visionary leader with over 11 years of experience in construction engineering.
                  </p>
              </div>
            </div>

            {/* Team Member 2 */}
            <div className="col">
              <div className="card h-100 bg-white text-center">
                <img
                  src={Professional01} 
                  className="card-img-top mx-auto mt-3 rounded-circle"
                  alt="Team Member Name"
                  style={{ width: '150px', height: '150px', objectFit: 'center' }}
                />
                  <h5 className="card-title mb-1">Andy Mthembu</h5>
                  <p className="card-text small">Head of Operations</p>
                  <p className="card-text">
                    Ensuring seamless project execution and operational efficiency.
                  </p>
              </div>
            </div>

            <div className="col">
              <div className="card h-100 bg-warning text-center">
                <img
                  src={Professional02} 
                  className="card-img-top mx-auto mt-3 rounded-circle"
                  alt="Team Member Name"
                  style={{ width: '150px', height: '150px', objectFit: 'center' }}
                />
                  <h5 className="card-title mb-1">Liyanda Lushaba</h5>
                  <p className="card-text small">Project Manager</p>
                  <p className="card-text">
                    Specializing in Project Management and Quantity Survaying.
                  </p>
              </div>
            </div>

            {/* Team Member 4 */}
            {/* <div className="col">
              <div className="card h-100 bg-warning text-center">
                <img
                  src={Professional03} 
                  className="card-img-top mx-auto mt-3 rounded-circle"
                  alt="Team Member Name"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
                <div className="card-body">
                  <h5 className="card-title mb-1">Sarah Green</h5>
                  <p className="card-text small">HSE Manager</p>
                  <p className="card-text">
                    Dedicated to maintaining the highest safety and environmental standards.
                  </p>
                </div>
              </div>
            </div> */}

            {/* Add a team member card here if needed */}
            {/*
            <div className="col">
              <div className="card h-100 border-0 shadow-sm text-center">
                <img
                  src="https://via.placeholder.com/200x200?text=Team+Member+5"
                  className="card-img-top mx-auto mt-3 rounded-circle"
                  alt="Team Member Name"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
                <div className="card-body">
                  <h5 className="card-title mb-1">David Lee</h5>
                  <p className="card-text text-muted small">Project Coordinator</p>
                  <p className="card-text">
                    Ensuring projects are delivered on time and within budget.
                  </p>
                </div>
              </div>
            </div>
            */}
          </div>
        </section>

        {/* Our Philosophy & Approach (Vision, Mission, Why Choose Us) */}
        <section className="py-0 mb-5 position-relative z-1">
          <h3 className="mb-4 text-center">Our Philosophy & Approach</h3>
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
            {/* Vision Card */}
            <div className="col">
              <div className="card h-100">
                <div className="card-body text-center">
                  <i className="bi bi-eye display-5 text-warning mb-3"></i> 
                  <h5 className="card-title">Vision</h5>
                  <p className="card-text">
                    To be the leading provider of innovative construction and engineering solutions, delivering outstanding results that
                    exceed client expectations while building sustainable communities.
                  </p>
                </div>
              </div>
            </div>

            {/* Mission Card */}
            <div className="col">
              <div className="card h-100">
                <div className="card-body text-center">
                  <i className="bi bi-flag display-5 text-warning mb-3"></i> {/* Icon for Mission */}
                  <h5 className="card-title">Mission</h5>
                  <p className="card-text">
                    Our mission is to offer comprehensive and cost-effective services through professionalism, attention to detail, and
                    strategic project execution — always aiming for client satisfaction and environmental responsibility.
                  </p>
                </div>
              </div>
            </div>

            {/* Why Choose Us? Card */}
            <div className="col"> {/* Adjusted column size for better display if not 3 items */}
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title text-center d-flex align-items-center justify-content-center mb-3">
                    <i className="bi bi-patch-check display-5 text-warning me-3"></i> Why Choose Us?
                  </h5>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex align-items-center border-0 px-0">
                      <i className="bi bi-star-fill text-warning me-3"></i>
                      <strong>Highly Qualified Staff:</strong> Our team includes skilled professionals dedicated to excellence and results.
                    </li>
                    <li className="list-group-item d-flex align-items-center border-0 px-0">
                      <i className="bi bi-hand-thumbs-up-fill text-success me-3"></i>
                      <strong>Client Satisfaction:</strong> We tailor solutions to meet specific client needs and priorities.
                    </li>
                    <li className="list-group-item d-flex align-items-center border-0 px-0">
                      <i className="bi bi-check-circle-fill text-info me-3"></i>
                      <strong>Quality Management:</strong> We follow strict quality controls and industry standards at every project stage.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ownership & Management */}
        <section id="management" className="py-0 mb-5 position-relative z-1">
          <h3 className="mb-4 text-center">Ownership & Management</h3>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card border-0 shadow-sm p-4">
                <p className="text-center mb-0">
                  LIYO & SONS GROUP is a Broad-Based Black Economic Empowerment Level One Contributor. The company is led by a
                  <strong> Team</strong>, of young and vibrant leaders with in-depth knowledge in the construction industry and also passion
                  for community development and innovation.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div> {/* End of main content wrapper */}
    </div> // End of outermost div
  );
}

export default About;
